<!-- GoodsList.vue (Vue 2 兼容) -->
<template>
  <div class="goods-container">
    <van-tabs v-if="config['goods'][0].tabName !== '' " v-model="activeName">
      <van-tab v-if="config['listType'] === 'calendar'" v-for="(tab,index) in config['goods']" :key="index" :name="tab.tabName" >
        <template #title>
          <div style="display: flex;flex-direction: column;align-items:center;width: 40px;position: relative">
            <div v-if="tab.isNewDate" style="font-size: 10px;position: absolute;right: 0;top:-5px;color: #993333">新品</div>
            <div>{{formatLabel(new Date(Number(tab.tabName)))}}</div>
            <div>{{new Date(Number(tab.tabName)).getDate()}}</div>
          </div>
        </template>
        <div style="padding: 10px 0;overflow-x: auto">
          <div style="white-space: nowrap;display: flex;">
            <div
              v-for="(item, index) in tab.tabData"
              :key="index"
              style="margin-right: 10px"
            >
              <el-card v-if="item.productInfo" shadow="hover">
                <el-image
                  :src="`${$config.product_image_url}cover_image/${item.productInfo.coverImage}`"
                  fit="contain"
                  style="width: 150px; height: 120px"></el-image>
                <div class="goods-name">{{ item.productInfo.name }}</div>
                <div class="goods-price">¥{{ item.productInfo.price }}</div>
              </el-card>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab v-else v-for="(tab,idx) in config.goods" :key="idx" :title="tab.tabName" :name="tab.tabName">
        <el-row :gutter="20" style="margin-top: 10px" v-if="config['listType'] === 'normal'">
          <el-col
            v-for="(item, index) in tab.tabData"
            :key="index"
            :span="24 / config['columns']"
            class="goods-item"
          >
            <el-card shadow="hover" v-if="config['columns'] <= 2">
              <el-image
                style="width: 100%; height: 120px"
                :src="`${$config.product_image_url}cover_image/${item.productInfo.coverImage}`"
                fit="contain"></el-image>
              <div class="goods-name">{{ item.productInfo.name }}</div>
              <div class="goods-price">¥{{ item.productInfo.price }}</div>
            </el-card>
            <el-card shadow="hover" v-else :body-style="{padding: '0px'}">
              <el-image
                :src="`${$config.product_image_url}cover_image/${item.productInfo.coverImage}`"
                fit="contain"></el-image>
            </el-card>
          </el-col>
        </el-row>
        <div v-if="config['listType'] === 'nowrap'" style="padding: 10px 0;overflow-x: auto">
          <div style="white-space: nowrap;display: flex;">
            <div
              v-for="(item, index) in tab.tabData"
              :key="index"
              style="margin-right: 10px"
            >
              <el-card shadow="hover">
                <el-image
                  style="width: 150px; height: 120px"
                  :src="`${$config.product_image_url}cover_image/${item.productInfo.coverImage}`"
                  fit="contain"></el-image>
                <div class="goods-name">{{ item.productInfo.name }}</div>
                <div class="goods-price">¥{{ item.productInfo.price }}</div>
              </el-card>
            </div>
          </div>
        </div>
        <el-row
          v-if="config['listType'] === 'rank'"
          style="margin-top: 10px"
          v-for="(item, index) in tab.tabData"
          :key="index"
        >
          <el-card shadow="hover" >
            <div style="display: flex">
              <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-right: 20px">
                <div style="font-size: 10px;font-weight: 700;margin-bottom: 5px">TOP</div>
                <div style="font-weight: 700">{{index + 1}}</div>
              </div>
              <el-image
                style="width: 100px;height: 120px"
                :src="`${$config.product_image_url}cover_image/${item.productInfo.coverImage}`"
                fit="contain"></el-image>
              <div style="margin-left: 10px;display: flex;flex-direction: column;justify-content: center">
                <div class="goods-name">{{ item.productInfo.name }}</div>
                <div class="goods-price">¥{{ item.productInfo.price }}</div>
              </div>
            </div>
          </el-card>
        </el-row>
      </van-tab>
    </van-tabs>
    <el-row v-else :gutter="20" style="margin-top: 10px">
      <el-col
        v-for="(item, index) in config.goods[0].tabData"
        :key="index"
        :span="24 / config['columns']"
        class="goods-item"
      >
        <el-card shadow="hover" v-if="config['columns'] <= 2">
          <el-image
            style="width: 100%; height: 120px"
            :src="`${$config.product_image_url}cover_image/${item.productInfo.coverImage}`"
            fit="contain"></el-image>
          <div class="goods-name">{{ item.productInfo.name }}</div>
          <div class="goods-price">¥{{ item.productInfo.price }}</div>
        </el-card>
        <el-card shadow="hover" v-else :body-style="{padding: '0px'}">
          <el-image
            :src="`${$config.product_image_url}cover_image/${item.productInfo.coverImage}`"
            fit="contain"></el-image>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'GoodsList',
  props: {
    config: {
      type: Object,
      default: () => ({
        columns: 3,
        goods: []
      })
    }
  },
  watch: {},
  data(){
    return{
      activeName: 'a',
      weekDays: ['日', '一', '二', '三', '四', '五', '六']
    }
  },
  methods:{
    formatLabel(dateObj) {
      const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
      const dayIdx = dateObj.getDay();

      if(new Date().getDate() === dateObj.getDate()){
        return '今';
      }else if(new Date().getDate() - dateObj.getDate() === 1){
        return '昨';
      }else if(new Date().getDate() - dateObj.getDate() === -1){
        return '明';
      }else{
        return `${weekDays[dayIdx]}`;
      }
    },
  }
}
</script>

<style scoped>
.goods-container {
  padding: 15px 0;
}

.goods-item {
  margin-bottom: 20px;
}

.goods-name {
  font-size: 14px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-wrap: wrap;
}

.goods-price {
  color: #f56c6c;
  font-weight: bold;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/instrument/GoodsList.vue